import { subscribe } from 'valtio'

import { Environment, environment } from '../environment'

export const listenToEnvironmentReady = (listener: (env: Environment) => void) => {
  return subscribe(environment, () => {
    listener(environment.env)
  })
}
